/** Strips section tags ([[A0]]) and timestamp prefixes ([0.0:], [:]) from lyric text. */
export function sanitizeLyricLine(line: string): string {
  return line
    .replace(/\[\[[^\]]*\]\]/g, "")
    .replace(/\[[\d.:]*\]/g, "")
    .trim();
}

export function sanitizeLyricLines(lines: string[]): string[] {
  return lines.map(sanitizeLyricLine).filter(Boolean);
}

/** Expands lyric entries into individual display lines (handles embedded newlines). */
export function expandLyricLineEntries(lines: string[]): string[] {
  return lines.flatMap((line) =>
    sanitizeLyricLine(line)
      .split(/\r?\n/)
      .map((part) => part.trim())
      .filter(Boolean),
  );
}

export interface LyricsSectionLike {
  section_name?: string;
  lines?: string[];
}

/** Flat lyric lines for display — omits section names and splits multi-line entries. */
export function getDisplayLyricLines(
  lyricsSections: LyricsSectionLike[] | null | undefined,
): string[] {
  if (!lyricsSections?.length) return [];

  return lyricsSections.flatMap((section) => {
    const sectionName = section.section_name?.trim().toLowerCase();

    return expandLyricLineEntries(section.lines ?? []).filter((line) => {
      if (!sectionName) return true;
      return line.trim().toLowerCase() !== sectionName;
    });
  });
}
